import * as React from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import { useNavigate } from 'react-router-dom'
import { ListItemIcon, ListSubheader } from '@mui/material'
import DeleteSimulation from '../DeleteSimulation'
import EditSimulation from '../EditSimulation'
import CopySimulation from '../CopySimulation'
import SimulationIcon from '@mui/icons-material/AutoGraph'
import schema from '../../../schemas/simulation.json'
import copy from '../../../schemas/simulation_copy.json'
import { JSONSchema7 } from 'json-schema'
import { Simulation } from '../../../interfaces/simulation'
import { format } from 'date-fns'
import Grid from '@mui/material/Grid'
import CreateSimulation from '../CreateSimulation'
import CircularProgressWithLabel from '../../shared/CircularProgressWithLabel'

export interface Props {
  disabled: boolean
  data: Simulation[]
  setData: React.Dispatch<React.SetStateAction<any[]>>
}

export default function SimulationList({ data, setData, disabled }: Props) {
  const navigate = useNavigate()

  return (
    <List
      dense
      subheader={
        <ListSubheader>
          <Grid container alignItems={'center'}>
            {'Simulations'}
            <CreateSimulation
              disabled={disabled}
              data={data}
              schema={schema as JSONSchema7}
              setData={(d) => {
                setData([d, ...data])
              }}
            />
          </Grid>
        </ListSubheader>
      }
    >
      {data.map((obj: Simulation, index: number) => {
        return (
          <ListItem
            key={index}
            secondaryAction={
              <>
                <CopySimulation
                  schema={copy as JSONSchema7}
                  name={obj.simulation_name}
                  disabled={obj?.status?.running}
                  setData={(d: any) => {
                    setData(JSON.parse(d))
                  }}
                />
                <EditSimulation
                  disabled={obj?.status?.running}
                  data={data}
                  schema={schema as JSONSchema7}
                  value={obj}
                  setData={(d: any) => {
                    setData([d, ...data.filter((s) => s.simulation_name !== obj.simulation_name)])
                  }}
                />
                <DeleteSimulation
                  disabled={obj?.status?.running}
                  value={obj}
                  setData={() => {
                    setData(data.filter((s) => s.simulation_name !== obj.simulation_name))
                  }}
                />
              </>
            }
            disablePadding
          >
            <ListItemButton onClick={() => navigate(obj.simulation_name + '?tab=config')}>
              <ListItemIcon>
                {obj?.status?.running ? (
                  <CircularProgressWithLabel value={Math.round(obj?.status?.progress * 100.0)} />
                ) : (
                  <SimulationIcon sx={{ mx: 1 }} />
                )}
              </ListItemIcon>
              <ListItemText
                primary={obj.simulation_name}
                secondary={`${format(new Date(obj?.start_time), 'PP')} → ${format(
                  new Date(obj?.end_time),
                  'PP'
                )} (freq: ${obj?.ems_frequency}s)`}
                sx={{ '.MuiListItemText-secondary': { display: { xs: 'none', sm: 'block' } } }}
              />
            </ListItemButton>
          </ListItem>
        )
      })}
    </List>
  )
}
